import Routers from "./Routers";

function App() {
  return <Routers />;
}

export default App;
